import { Component, EventEmitter, HostListener, Input, OnInit, Output, SimpleChange, ViewChild } from '@angular/core';
import { NgbDateStruct, NgbInputDatepicker } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';

@Component({
  selector: 'app-date-range-picker',
  templateUrl: './date-range-picker.component.html',
  styleUrls: ['./date-range-picker.component.css']
})
export class DateRangePickerComponent implements OnInit {

  @ViewChild('dp') private datePicker: NgbInputDatepicker;
  @Input() from: Date;
  @Input() to: Date;
  @Input() placeholder = 'Select date range';
  @Input() resetDate;
  @Output() dateRangeSelection = new EventEmitter<{ from: Date, to: Date }>();
  hoveredDate: Date;
  isOpen = false;
  startDate = {
    day: 1,
    month: new Date().getMonth() + 1,
    year: new Date().getFullYear(),
  }
  endDate = {
    day: new Date().getDate(),
    month: new Date().getMonth() + 1,
    year: new Date().getFullYear(),
  }

  @HostListener('document:click', ['$event.target']) onClick(element) {
    const host = document.getElementById('dateRangePicker');
    if (this.datePicker && this.isOpen && !this.isDescendant(host, element)) {
      this.emit(true);
    }
  }

  constructor() { }

  ngOnInit() {
    if (!this.from && !this.to) {
      this.getDefaultSelectedDate();
    }
  }
  getDefaultSelectedDate(){
    this.onDateSelection(this.startDate);
    this.onDateSelection(this.endDate);
  }
  ngOnChanges(changes: SimpleChange) {
    if (changes["resetDate"]) {
      this.getDefaultSelectedDate();
    }

  }
  private emit(close?: boolean) {
    const dateRange = {
      from: this.from,
      to: this.to ? this.to : new Date(),
    };

    this.dateRangeSelection.emit(dateRange);

    if (close) {
      this.isOpen = false;
      this.to == null ? this.onDateSelection(this.endDate): '';
      this.datePicker?.close();
    }
  }

  /**
   * Check whether or not an element is a child of another element
   *
   * @private
   * @param {any} parent
   * @param {any} child
   * @returns if child is a descendant of parent
   * @memberof DateRangeSelectionComponent
   */
  private isDescendant(parent, child) {
    let node = child;
    while (node !== null) {
      if (node === parent) {
        return true;
      } else {
        node = node.parentNode;
      }
    }
    return false;
  }

  get formattedDateRange(): string {
    if (!this.from) {
      return `Select date range`;
    }

    const fromFormatted = moment(this.from).format('MM-DD-YYYY');

    return this.to      
      ? `${fromFormatted}`
      + ` - `
      + `${moment(this.to).format('MM-DD-YYYY')}`
      : `${fromFormatted}`;

  }

  onDateSelection(date: NgbDateStruct) {
    if (!this.from && !this.to) {
      this.from = this.toDate(date);
    } else if (this.from && !this.to && this.toMoment(date).isAfter(this.from)) {
      this.to = this.toDate(date);
      this.emit(true);
    } else {
      this.to = null;
      this.from = this.toDate(date);
    }
  }

  toDate(dateStruct: NgbDateStruct): Date {
    return dateStruct ? new Date(dateStruct.year, dateStruct.month - 1, dateStruct.day) : null;
  }

  toMoment(dateStruct: NgbDateStruct): moment.Moment {
    return moment(this.toDate(dateStruct));
  }

  isHovered = (date: NgbDateStruct) => this.from && !this.to && this.hoveredDate
    && this.toMoment(date).isAfter(this.from) && this.toMoment(date).isBefore(this.hoveredDate);

  isInside = (date: NgbDateStruct) => this.toMoment(date).isAfter(moment(this.from).startOf('day')) && this.toMoment(date).isBefore(moment(this.to).startOf('day'));
  isFrom = (date: NgbDateStruct) => this.toMoment(date).isSame(this.from, 'd');
  isTo = (date: NgbDateStruct) => this.toMoment(date).isSame(this.to, 'd');

}
